export default "__VITE_ASSET__CkQ$lMOE__"